import { defineComponent as _defineComponent } from 'vue'
import DOMPurify from 'dompurify'
import { nextTick, ref } from 'vue'

import { renderAssistantMarkdown } from './assistant-markdown'

import type {
  AssistantMessage,
  AssistantSession,
  OrderImportCardState,
  ProductionHistoryCardState,
} from './assistant-models'
import GAssistantImportOrdersCard from './g-assistant-import-orders-card.vue'
import GAssistantProductionHistoryCard from './g-assistant-production-history-card.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'g-assistant-timeline',
  props: {
    session: null
  },
  emits: ["update-order-state", "import-order", "change-order-page", "update-production-state", "export-production", "change-production-page"],
  setup(__props: any, { expose, emit: emits }: { emit: ({
  (
    event: 'update-order-state',
    message: AssistantMessage,
    state: OrderImportCardState
  ): void
  (event: 'import-order', message: AssistantMessage): void
  (event: 'change-order-page', message: AssistantMessage, page: number): void
  (
    event: 'update-production-state',
    message: AssistantMessage,
    state: ProductionHistoryCardState
  ): void
  (event: 'export-production', message: AssistantMessage): void
  (
    event: 'change-production-page',
    message: AssistantMessage,
    page: number
  ): void
}), expose: any, slots: any, attrs: any }) {





const messagesRef = ref<HTMLElement | null>(null)

function scrollToBottom() {
  nextTick(() => {
    if (messagesRef.value)
      messagesRef.value.scrollTop = messagesRef.value.scrollHeight
  })
}

expose({ scrollToBottom })

return { __sfc: true,emits, messagesRef, scrollToBottom, DOMPurify, renderAssistantMarkdown, GAssistantImportOrdersCard, GAssistantProductionHistoryCard }
}

})